var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00333254 0.5C-0.27281 0.5 -0.496667 0.723858 -0.496667 1C-0.496667 1.27614 -0.27281 1.5 0.00333254 1.5H20C20.2761 1.5 20.5 1.27614 20.5 1C20.5 0.723858 20.2761 0.5 20 0.5H0.00333254ZM0 7.16556C-0.276142 7.16556 -0.5 7.38941 -0.5 7.66556C-0.5 7.9417 -0.276142 8.16556 0 8.16556H19.9917C20.2678 8.16556 20.4917 7.9417 20.4917 7.66556C20.4917 7.38941 20.2678 7.16556 19.9917 7.16556H0ZM0.00333254 13.8311C-0.27281 13.8311 -0.496667 14.055 -0.496667 14.3311C-0.496667 14.6073 -0.27281 14.8311 0.00333254 14.8311H19.9917C20.2678 14.8311 20.4917 14.6073 20.4917 14.3311C20.4917 14.055 20.2678 13.8311 19.9917 13.8311H0.00333254Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.ca0612272f768e533551675274879519.svg";
export { ForwardRef as ReactComponent };